// extracted by mini-css-extract-plugin
export default {"container":"BusinessHour_container__aekZg","box":"BusinessHour_box__trfhy","hour":"BusinessHour_hour__GcmCr","hours_desc":"BusinessHour_hours_desc__Abtsl"};